import { useQuery } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { COMMERCE } from '@shared/api/endpoints';
import type { CommerceProduct } from '@tailorcast/shared-types';

interface ProductsParams {
  page?: number;
  limit?: number;
  sort?: string;
  category?: string;
  minScore?: number;
  maxScore?: number;
}

interface ProductsResponse {
  products: CommerceProduct[];
  total: number;
  page: number;
  totalPages: number;
}

export function useProducts(params: ProductsParams = {}) {
  const { page = 1, limit = 50, sort, category, minScore, maxScore } = params;

  const searchParams = new URLSearchParams();
  searchParams.set('page', String(page));
  searchParams.set('limit', String(limit));
  if (sort) searchParams.set('sort', sort);
  if (category) searchParams.set('category', category);
  if (minScore != null) searchParams.set('minScore', String(minScore));
  if (maxScore != null) searchParams.set('maxScore', String(maxScore));

  const url = `${COMMERCE.PRODUCTS}?${searchParams.toString()}`;

  return useQuery({
    queryKey: ['products', params],
    queryFn: () => api.get<ProductsResponse>(url),
  });
}
